import { Create, ImageField, ImageInput, NumberInput, ReferenceInput, required, SelectInput, SimpleForm, TextInput, useLocaleState } from "react-admin";
import { makeStyles } from "@mui/styles";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { EntryType } from "../../../../shared/enums/start-page.enum";

const useStyles = makeStyles({
    inlineBlock: { display: "inline-flex", marginRight: "1rem" },
});

const getSourceForType = (type: string) => {
    switch (type) {
        case EntryType.Path:
            return 'paths';

        case EntryType.Poi:
            return 'pois';

        case EntryType.PathCategory:
            return 'pathCategories';

        case EntryType.PoiCategory:
            return 'poiCategories';

        case EntryType.Aoi: 
            return 'aois';
        
        case EntryType.AoiCategory:
            return 'aoiCategories';

        case EntryType.Area:
            return 'areas';

        default:
            return '';
    }
};

export const StartPageRowEntryCreate = () => {
    const classes = useStyles();
    const [referenceSource, setReferenceSource] = useState('');
    const [entryType, setEntryType] = useState('');

    const { rowId } = useParams();

    const [locale] = useLocaleState();

    return (
        <Create resource="startpages/entries" redirect={`/startpages/rows/${rowId}/entries`}>
            <SimpleForm>
                <SelectInput source="entryType" validate={[required()]} onChange={e => {
                    const type = e.target.value;
                    setEntryType(type);
                    setReferenceSource(getSourceForType(type));
                }} choices={[
                    { name: 'Path', id: EntryType.Path },
                    { name: 'Poi', id: EntryType.Poi },
                    { name: 'Path Category', id: EntryType.PathCategory },
                    { name: 'Poi Category', id: EntryType.PoiCategory },
                    { name: 'Aoi', id: EntryType.Aoi },
                    { name: 'Aoi Category', id: EntryType.AoiCategory },
                    { name: 'Area', id: EntryType.Area },
                    { name: 'Status Reports', id: EntryType.StatusReports }
                ]}/>
                { referenceSource && (
                    <>
                        <ReferenceInput source="entryId" reference={referenceSource}>
                            <SelectInput optionText={`name.${locale}`} label="Category" validate={[required()]} />
                        </ReferenceInput>
                        <NumberInput source="priority"/>
                    </>
                )}
                { entryType === EntryType.StatusReports && (
                    <>
                        <TextInput readOnly source="entryId" defaultValue={0} style={{display:'none'}}/>
                        <NumberInput source="priority"/>
                    </>
                )}

                <ImageInput source="media" multiple={false}>
                    <ImageField source="src" title="title" />
                </ImageInput>

                <TextInput readOnly source="rowId" defaultValue={rowId} style={{display:'none'}}/>
            </SimpleForm>
        </Create>
    );
};